import { SPACE } from "~/shared/lib/design-tokens";
import { cn } from "~/shared/lib/utils";

import { Section, TileBtn } from "./SettingsTiles";

interface TileSectionProps<T> {
    label: string;
    hint?: string;
    options: readonly T[];
    active: T;
    onSelect: (value: T) => void;
    renderLabel: (value: T) => string;
    /** flex-wrap грид (true) или однострочный flex (false, как у batchSize). */
    wrap?: boolean;
    /**
     * Значение недоступно при текущих настройках. Плитка остаётся на месте
     * заблокированной — решение владельца: недоступное показываем, а не прячем,
     * иначе набор опций молча меняется от модели к модели.
     */
    isDisabled?: (value: T) => boolean;
    /** Причина блокировки конкретной плитки — тултипом на ней. */
    disabledHint?: string;
}

// Секция настроек со списком взаимоисключающих TileBtn-тайлов
// (mode / aspectRatio / resolution / duration / batchSize).
export function TileSection<T extends string | number>({
    label,
    hint,
    options,
    active,
    onSelect,
    renderLabel,
    wrap = true,
    isDisabled,
    disabledHint,
}: TileSectionProps<T>) {
    return (
        <Section label={label} hint={hint}>
            <div className={cn("flex", wrap && "flex-wrap", SPACE.tiles)}>
                {options.map((option) => {
                    const disabled = isDisabled?.(option) ?? false;
                    return (
                        <TileBtn
                            key={option}
                            label={renderLabel(option)}
                            active={active === option}
                            disabled={disabled}
                            title={disabled ? disabledHint : undefined}
                            onClick={() => onSelect(option)}
                        />
                    );
                })}
            </div>
        </Section>
    );
}
